// extracted by mini-css-extract-plugin
export default {"melodyVideo":"YQ-z","isFullWidth":"ZQ-z","landingPageVideo":"_Q-z","play":"aR-z","iframeVideo":"bR-z","playHidden":"cR-z","fullwidth":"dR-z"};